module.exports = __webpack_public_path__ + "static/about-207f890b9f2143b1cac10a9ad27327f7.png";